import { render, staticRenderFns } from "./Loding.vue?vue&type=template&id=0ba359eb&scoped=true&"
var script = {}
import style0 from "./Loding.vue?vue&type=style&index=0&id=0ba359eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba359eb",
  null
  
)

export default component.exports